import PropTypes from 'prop-types';

export const Node = (() => {
  const shape = {
    content: PropTypes.node,
    key: PropTypes.string.isRequired,
    selected: PropTypes.boolean,
    style: PropTypes.object,
    onClick: PropTypes.func,
    defaultOpen: PropTypes.boolean
  };

  shape.childrenNodes = PropTypes.arrayOf(PropTypes.shape(shape));

  return PropTypes.shape(shape);
})();
